<template>
  <v-overlay :dark="true" :absolute="true" opacity="0.8" v-if="loading">
    <lottie :options="lottieOptions" :height="250" :width="250"/>
  </v-overlay>
</template>

<script>
import * as animationData from "@/assets/animations/loading.json";

export default {
  name: "LoadingOverlay",
  props: {
    loading: Boolean,
    color: String
  },
  data() {
    return {
      lottieOptions: { animationData: animationData.default },
    };
  }
}
</script>